export type TLanguageDef = {
  i18nextCode: string; // the locale code as i18next is aware of it
  sitePathRoot: string; // this will be shown in the root of the path
  localeCode: string; // the full locale to be used in the hrefLang
  nativeName: string; // the name to show in the menu (native language name)
};

export const SITE_LANGUAGES: TLanguageDef[] = [
  {
    i18nextCode: 'de',
    sitePathRoot: 'de',
    localeCode: 'de-de',
    nativeName: 'Deutsch'
  },
  {
    i18nextCode: 'en',
    sitePathRoot: '',
    localeCode: 'en-us',
    nativeName: 'English'
  },
  {
    i18nextCode: 'es',
    sitePathRoot: 'es',
    localeCode: 'es-es',
    nativeName: 'Español'
  },
  {
    i18nextCode: 'fr',
    sitePathRoot: 'fr',
    localeCode: 'fr-fr',
    nativeName: 'Français'
  },
  {
    i18nextCode: 'it',
    sitePathRoot: 'it',
    localeCode: 'it-it',
    nativeName: 'Italiano'
  },
  {
    i18nextCode: 'pt',
    sitePathRoot: 'br',
    localeCode: 'pt-br',
    nativeName: 'Português Brasileiro'
  },
  {
    i18nextCode: 'uk',
    sitePathRoot: 'uk',
    localeCode: 'uk-ua',
    nativeName: 'Українська'
  },
  {
    i18nextCode: 'ru',
    sitePathRoot: 'ru',
    localeCode: 'ru-ru',
    nativeName: 'Русский'
  },
  {
    i18nextCode: 'ko',
    sitePathRoot: 'kr',
    localeCode: 'ko-kr',
    nativeName: '한국어'
  },
  {
    i18nextCode: 'zh',
    sitePathRoot: 'cn',
    localeCode: 'zh-cn',
    nativeName: '简体中文'
  }
];
